{
  "dropzoneLabel": "„DropZone“",
  "selectPlaceholder": "Pasirinkite elementą",
  "tableResizer": "Dydžio keitiklis",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
